import { Component, Inject } from '@angular/core';
import { IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { ShowTermsModal } from '../../../../../core/modals/show-terms/show-terms.modal';
import { TermsResponse } from './terms.response';

@Component({
  selector: 'gtd-widget-profile-terms',
  templateUrl: './terms.component.html',
})
export class TermsComponent extends GtdNgWidgetComponentAbstract {
  protected readonly key: string = 'AffiliateCrm\\CrmDocuments\\CrmDocuments';
  public data = new TermsResponse();

  constructor(@Inject(IMODALS_SERVICE) private modalsService: IModalsService) {
    super();
  }

  public openModal(docs: TermsResponse['crm_terms']): void {
    this.modalsService.open(ShowTermsModal, { docs });
  }
}
